import { render, staticRenderFns } from "./carihareketbaseaktarim.vue?vue&type=template&id=a83d04ce"
import script from "./carihareketbaseaktarim.vue?vue&type=script&lang=js"
export * from "./carihareketbaseaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports